export function formatCzkPrice(price: string | number | null | undefined) {
  if (price === null || price === undefined || price === "" || price === "0") {
    return "Neuvedeno";
  }

  const normalizedPrice = String(price).trim();
  const numericPrice = Number(normalizedPrice.replace(/[^\d]/g, ""));

  if (!Number.isFinite(numericPrice) || numericPrice <= 0) {
    return normalizedPrice;
  }

  const formattedPrice = new Intl.NumberFormat("cs-CZ")
    .format(numericPrice)
    .replace(/\u00a0/g, " ");

  return `${formattedPrice} Kč`;
}
